import request from '@/utils/request'


// 查询佣金下发列表
export function listBrokerage(query) {
  return request({
    url: '/user/brokerage-head/list',
    method: 'get',
    params: query
  })
}

// 查询佣金下发分页
export function pageBrokerage(query) {
  return request({
    url: '/user/brokerage-head/page',
    method: 'get',
    params: query
  })
}

// 查询佣金下发分页
export function pageBrokerageDetail(query) {
  return request({
    url: '/user/brokerage-detail/page',
    method: 'get',
    params: query
  })
}

// 查询佣金下发分页
export function pageBrokerageDetailByUser(query) {
  return request({
    url: '/user/brokerage-detail/pageByUser',
    method: 'get',
    params: query
  })
}

export function pageUserByTopUser(query) {
  return request({
    url: '/user/brokerage-detail/pageUserByTopUser',
    method: 'get',
    params: query
  })
}

// 查询佣金下发详细
export function getBrokerage(data) {
  return request({
    url: '/user/brokerage-head/detail',
    method: 'get',
    params: data
  })
}

// 新增佣金下发
export function addBrokerage(data) {
  return request({
    url: '/user/brokerage-head/add',
    method: 'post',
    data: data
  })
}

export function approve(data) {
  return request({
    url: '/user/brokerage-head/approve',
    method: 'post',
    data: data
  })
}

// 修改佣金下发
export function updateBrokerage(data) {
  return request({
    url: '/user/brokerage-head/edit',
    method: 'post',
    data: data
  })
}

// 删除佣金下发
export function delBrokerage(data) {
  return request({
    url: '/user/brokerage-head/delete',
    method: 'post',
    data: data
  })
}
